<template>
  <v-card data-qa="rolelist-card-hbz68l">
    <v-card-title class="role-card-title" data-qa="rolelist-card-title-u2jzzk">
      <span data-qa="rolelist-span-gksh5f">{{ t.viewRoles }}</span>
      <v-spacer data-qa="rolelist-spacer-fwqk4"  />
      <v-btn icon @click="$emit('refreshRoles')" data-qa="rolelist-btn-b6t6al">
        <v-tooltip top :color="primaryColor" data-qa="rolelist-tooltip-cbupq3j">
          <template v-slot:activator="{ on, attrs }">
            <v-icon large :color="primaryColor" v-bind="attrs" v-on="on" data-qa="rolelist-icon-y3uscg">mdi-refresh</v-icon>
          </template>
          <span data-qa="rolelist-span-72ybc">Reload</span>
        </v-tooltip>
      </v-btn>
    </v-card-title>
    <v-card-text data-qa="rolelist-card-text-l28gjx">
      <v-data-table
        @click:row="viewItem"
        :headers="headers"
        :items="roles"
        :items-per-page="20"
        :item-class="itemClass"
        :footer-props="{
          'items-per-page-options': [20],
          'disable-items-per-page': true,
        }"
       data-qa="rolelist-data-table-qlc5em">
        <template v-if="isEditRolesPermitted" v-slot:item.actions="{ item }">
          <v-tooltip top :color="primaryColor" data-qa="rolelist-tooltip-1t9e0g">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="!isGlobalRole(item)" @click.stop="editItem(item)" :color="primaryColor" v-bind="attrs" v-on="on" data-qa="rolelist-icon-yq6v6l">
              mdi-pencil-outline
              </v-icon>
            </template>
            <span data-qa="rolelist-span-wrgp0x">Edit</span>
            </v-tooltip>
          <v-tooltip top :color="primaryColor" data-qa="rolelist-tooltip-j6agff">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="!isGlobalRole(item)" @click.stop="deleteItem(item)" :color="primaryColor" v-bind="attrs" v-on="on" data-qa="rolelist-icon-n84vr">
              mdi-delete-outline
              </v-icon>
            </template>
            <span data-qa="rolelist-span-gjpxgb">Delete</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import '@/styles/pages/roles/roles.scss'
import store from '@/core/store'

export default {
  name: 'RoleList',
  props: {
    roles: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      headers: null,
      selectedRoleCode: null,
      permissions: [],
      isEditRolesPermitted: false,
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  created () {
    const { t } = this
    this.headers = [
      { text: t.roleName, value: 'roleCode', width: '25%', cellClass: 'role-wrap-text' },
      { text: t.description, value: 'roleDesc', width: '60%', cellClass: 'role-wrap-text' },
      { text: t.actions, value: 'actions', width: '15%', sortable: false }
    ]

    // Fetch Permissions for SME Users
    this.permissions = store.getters['profileStore/profileData']?.permissions
    this.isEditRolesPermitted = this.enableRoleBasedAccess ? this.permissions?.includes('ADD_EDIT_AND_DELETE_ROLES') : true
  },
  methods: {
    isGlobalRole (item) {
      return item?.defaultRoleFlag === 'Y'
    },
    editItem (item) {
      this.$emit('editRole', item)
    },
    deleteItem (item) {
      this.$emit('deleteRole', item)
    },
    viewItem (item) {
      this.selectedRoleCode = item.roleCode
      this.$emit('viewRole', item)
    },
    itemClass (item) {
      return item.roleCode === this.selectedRoleCode ? 'selected-row' : ''
    }
  },
  computed: {
    t () {
      const t = key => this.$t(`roleMaintenance.${key}`)
      return {
        viewRoles: t('viewRoles'),
        roleName: t('roleName'),
        description: t('description'),
        actions: t('actions')
      }
    }
  }
}
</script>
